import { roundFloat } from "client/utils/roundFloat";
import { Unit } from "store/types/unit";

export function roundDimension(unit: Unit, dimension: number): number {
    return unit === "pixels" ? Math.round(dimension) : roundFloat(dimension);
}
